import { Badge } from '@chakra-ui/react'

export const ReactBadge = () => {
    return <Badge colorScheme={'teal'}>ReactJS</Badge>
}

export const PythonBadge = () => {
    return <Badge colorScheme={'blue'}>Python</Badge>
}

export const PHPBadge = () => {
    return <Badge colorScheme={'purple'}>PHP</Badge>
}

export const JavaBadge = () => {
    return <Badge colorScheme={'red'}>Java</Badge>
}

export const MySQLBadge = () => {
    return <Badge colorScheme={'orange'}>MySQL</Badge>
}

export const MongoBadge = () => {
    return <Badge colorScheme={'green'}>MongoDB</Badge>
}

export const NodeBadge = () => {
    return <Badge colorScheme={'green'}>NodeJS</Badge>
}

export const FirebaseBadge = () => {
    return <Badge colorScheme={'orange'}>Firebase</Badge>
}

export const AssemblyBadge = () => {
    return <Badge colorScheme={'orange'}>Assembly</Badge>
}

export const DjangoBadge = () => {
    return <Badge colorScheme={'green'}>Django</Badge>
}

export const TypescriptBadge = () => {
    return <Badge colorScheme={'blue'}>Typescript</Badge>
}

export const HtmlBadge = () => {
    return <Badge colorScheme={'blue'}>HTML</Badge>
}

export const CSSBadge = () => {
    return <Badge colorScheme={'blue'}>CSS</Badge>
}

export const JavaScriptBadge = () => {
    return <Badge colorScheme={'blue'}>JavaScript</Badge>
}


